module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumbs', {
    attrs: {
      "crumbs": [{
        name: 'Administrative Settings'
      }, {
        name: 'Email Settings',
        link: 'Email Settings'
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_c('div', {
    staticClass: "portlet-title tabbable-line"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.name,
      class: {
        active: _vm.activeTab === tab.name
      },
      on: {
        "click": function($event) {
          return _vm.setActiveTab(tab.name)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": ("#" + (tab.name)),
        "data-toggle": "tab",
        "aria-expanded": "false"
      }
    }, [_vm._v("\n                " + _vm._s(tab.label) + "\n              ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "tab-content marginTop"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('div', {
      key: tab.name,
      staticClass: "tab-pane",
      class: {
        active: _vm.activeTab === tab.name
      },
      attrs: {
        "id": tab.name
      }
    }, [_c(tab.component, {
      tag: "component"
    })], 1)
  }), 0)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption caption-md"
  }, [_c('i', {
    staticClass: "icon-settings font-dark"
  }), _vm._v(" "), _c('span', {
    staticClass: "caption-subject font-dark sbold uppercase"
  }, [_vm._v("Email Settings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01c0acca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EmailSettings.vue
// module id = 1535
// module chunks = 1